<div class="user-autocomplete-container">
  <mat-form-field class="full-width">
    <mat-chip-list #chipList>
      <mat-chip
        *ngFor="let user of selectedUsers"
        [removable]="!disabled"
        (removed)="removeUser(user.id)"
        class="user-chip"
      >
       {{ user.client }}
        <mat-icon matChipRemove *ngIf="!disabled">cancel</mat-icon>
      </mat-chip>
      <input
        #searchInput
        matInput
        [placeholder]="selectedUsers.length === 0 ? placeholder : ''"
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onUserSelected($event.option.value)">
      <mat-option *ngIf="isSearching" disabled>
        <mat-spinner diameter="20"></mat-spinner>
        Buscando...
      </mat-option>
      <mat-option *ngFor="let user of filteredUsers" [value]="user">
        <span class="user-option">
          <strong>{{ user.username }}</strong> - {{ user.client }}
          <span class="user-phone" *ngIf="user.phone">({{ user.phone }})</span>
        </span>
      </mat-option>
      <mat-option *ngIf="!isSearching && filteredUsers.length === 0 && searchControl.value && searchControl.value.length >= 2" disabled>
        No se encontraron usuarios
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>

